
export class PageLoadHookRunner {

  constructor() {
    this._hooks = [];
  }

  get hooks() {
    return this._hooks;
  }

  onPageLoad() {
    this.hooks.forEach((hook) => {
      try {
        console.log(`Loading ${hook.name}`);
        hook.onPageLoad();
      } catch (err) {
        console.error(err);
      }
    });
  }
}
